import { fabric } from 'fabric'
import { StoredTemplate, Template } from '../types/Individualization'
import { Object } from 'fabric/fabric-impl'

export const resizeEverything = (
    canvas: fabric.Canvas,
    wrapper: HTMLElement,
    dimension: number = 1000
) => {
    const boundingBox = wrapper.getBoundingClientRect()
    const size = Math.min(boundingBox.width, boundingBox.height)

    canvas.setWidth(size - 2)
    canvas.setHeight(size - 2)

    const scale = (size - 2) / dimension

    canvas.setZoom(scale)

    if (
        canvas.backgroundImage &&
        canvas.backgroundImage instanceof fabric.Image
    ) {
        const scaleRatio = Math.min(
            dimension / canvas.backgroundImage.getOriginalSize().width,
            dimension / canvas.backgroundImage.getOriginalSize().height
        )

        canvas.backgroundImage.set({
            scaleX: scaleRatio,
            scaleY: scaleRatio,
            top: dimension / 2,
            left: dimension / 2,
        })
    }
}

export const addCanvasToWrapper = (
    canvas: fabric.Canvas,
    wrapper: HTMLElement,
    cleanup: boolean = false
) => {
    if (cleanup) {
        wrapper.innerHTML = ''
    }

    wrapper.append(canvas.getElement())
    wrapper.append(canvas.getSelectionElement())
}

export const changeBackground = (
    template: StoredTemplate | Template,
    canvas: fabric.Canvas
) => {
    fabric.Image.fromURL(
        'base64' in template ? template.base64 : template.src,
        (fabricImage: fabric.Image) => {
            const scale = canvas.getWidth() / canvas.getZoom()

            const img = fabricImage.set({
                originX: 'center',
                originY: 'center',
                centeredScaling: true,
                left: scale / 2,
                top: scale / 2,
            })

            const scaleRatio = Math.min(
                scale / img.getScaledWidth(),
                scale / img.getScaledHeight()
            )

            canvas.setBackgroundImage(
                img as fabric.Image,
                canvas.renderAll.bind(canvas),
                {
                    scaleX: scaleRatio,
                    scaleY: scaleRatio,
                }
            )
        }
    )
}
export const rescaleFabricObject = (object: fabric.Object): Object => {
    if (object.top) object.set('top', Math.round(object.top * 100) / 100)
    if (object.left) object.set('left', Math.round(object.left * 100) / 100)
    if (object.angle) object.set('angle', Math.round(object.angle * 100) / 100)

    if (object.height && object.scaleY) {
        object.set(
            'height',
            Math.round(object.height * object.scaleY * 100) / 100
        )
    }
    if (object.width && object.scaleX) {
        object.set(
            'width',
            Math.round(object.width * object.scaleX * 100) / 100
        )
    }

    //Ellipse
    if (object instanceof fabric.Ellipse && object.ry && object.scaleY) {
        object.set('ry', Math.round(object.ry * object.scaleY * 100) / 100)
    }
    if (object instanceof fabric.Ellipse && object.rx && object.scaleX) {
        object.set('rx', Math.round(object.rx * object.scaleX * 100) / 100)
    }

    //Circle
    if (object instanceof fabric.Circle && object.radius && object.scaleX) {
        object.set(
            'radius',
            Math.round(object.radius * object.scaleX * 100) / 100
        )
    }

    //Polygon
    if (
        (object instanceof fabric.Polygon ||
            object instanceof fabric.Polyline) &&
        object.points
    ) {
        if (!object.points) return object

        // 1 .Transformationsmatrix berechnen
        const matrix = object.calcTransformMatrix()

        // 3. Relative Punkte berechnen und in absolute Punkte umwandeln
        const points = object.points.map((point) => {
            const relativePoint = new fabric.Point(
                point.x - object.pathOffset.x,
                point.y - object.pathOffset.y
            )

            return fabric.util.transformPoint(relativePoint, matrix)
        })

        // 5. Polygon mit neuen Werten aktualisieren
        object.set({
            points,
            pathOffset: object.getCenterPoint(),
            scaleX: 1,
            scaleY: 1,
            angle: object.angle ?? 0,
        })
    }

    if (object instanceof fabric.Image) {
        // Images have a different scaling logic
    }

    object.set({
        scaleX: 1,
        scaleY: 1,
    })

    return object
}
